import { all } from 'redux-saga/effects';
import initializeAppSaga from './initializeApp';
import publicDashboardSagas from './publicDashboardSagas';
import publicDeviceSaga from './publicDeviceSaga';

export default function* sagas() {
    yield all([initializeAppSaga(), publicDeviceSaga(), publicDashboardSagas()]);
}
